module.exports = __webpack_public_path__ + "img/art_2_1.c512eaef.jpeg";